import React from "react"
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import CCOLinkable from "../../fundamentals/CCOLinkable";
import useWindowSize from "../../../utility/useWindowSize";
import useConsentLayerTrigger from "../../../utility/consentManagement/useConsentLayerTrigger";
import {useTranslation} from "react-i18next";
import {CmCollectionType} from "../../types";


import type {CAEGlobalSettings} from "../../../types/CAEGlobalSettings";

export interface Props {
    cmCollection: CmCollectionType,
    CAEGlobalSettings: CAEGlobalSettings,
    pageProps?: any
}

const privacySettingStyle = {
    background: 'transparent',
    border: 0,
    cursor: 'pointer',
    fontSize: '1rem',
    letterSpacing: '0.17px',
    lineHeight: '143%',
    padding: '8px 0',
    textAlign: 'left',
} as const;

export const copyRightStyle = {
    fontSize: 16,
    fontFamily: '"HelveticaNeueLTStd", Helvetica, Arial, sans-serif',
    paddingBottom: 1
}

function C074CopyrightNavi(props: Props) {
    const {t} = useTranslation();
    const {lowerThanWindowLarge, lowerThanWindowSmall} = useWindowSize();
    const {openConsentLayer, triggerRef} = useConsentLayerTrigger<HTMLButtonElement>();

    const gridStyle = {
        alignSelf: 'start',
        width: '100%',
        height: '100%',
        padding: '24px 16px 16px 16px',
    }

    const stackStyleCenter = {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        alignContent: 'center',
    }

    const noStackStyle = {}
    return (
        <>
            <Box sx={gridStyle}>
                <Stack
                    direction="row"
                    style={lowerThanWindowLarge ? stackStyleCenter : noStackStyle}
                    sx={{
                        alignItems: "center",
                        gap: 4
                    }}>
                    <Typography
                        sx={copyRightStyle}> &copy; {new Date().getFullYear()} {props.CAEGlobalSettings["copyright"]} </Typography>
                </Stack>
                <Stack
                    direction={lowerThanWindowSmall ? 'column' : 'row'}
                    style={lowerThanWindowLarge ? stackStyleCenter : noStackStyle}
                    sx={{
                        alignItems: "center",
                        gap: lowerThanWindowSmall ? 0 : 4
                    }}>
                    {
                        props.cmCollection.items?.map((item: any, index: number) => (
                            <CCOLinkable dataCypress={'copyRightLink' + index}
                                         type={"footer"} key={index} target={item}
                                         name={item.teaserTitle}/>
                        ))
                    }
                    <Typography
                        component='button'
                        data-cypress='privacySettingsLink'
                        onClick={openConsentLayer}
                        ref={triggerRef}
                        sx={{color: "footerLink.main", ...privacySettingStyle}}
                        type='button'
                        variant='linkLabel'>
                        {t('c074_privacy_settings')}
                    </Typography>
                </Stack>
            </Box>
        </>
    );
}

export default C074CopyrightNavi